import { get } from "../shared/api-client";
import { JIVANDHARA_BASE, SILENT_LIST } from "./list-api-helpers";

export interface GruhUdhyogDashboardSummary {
  products: number;
  orders_7_days: number;
  orders_to_fulfil: number;
  revenue_7_days: string | number;
  categories: number;
}

export interface GruhUdhyogRevenueSnapshot {
  date: string;
  day: string;
  amount: string | number;
}

export interface GruhUdhyogCategoryDistribution {
  name: string;
  product_count: number;
  percentage: number;
}

export interface GruhUdhyogRecentOrder {
  id: number;
  order_number: string;
  customer_name: string;
  items_count: number;
  date: string;
  time: string;
  amount: string | number;
  status: string;
}

export interface GruhUdhyogDashboardData {
  summary: GruhUdhyogDashboardSummary;
  revenue_snapshot: GruhUdhyogRevenueSnapshot[];
  categories: GruhUdhyogCategoryDistribution[];
  recent_orders: GruhUdhyogRecentOrder[];
  top_rated: any[];
}

export interface GruhUdhyogDashboardApiResponse {
  success: boolean;
  message: string;
  data: GruhUdhyogDashboardData;
}

class GruhUdhyogDashboardService {
  fetch = async (): Promise<GruhUdhyogDashboardData> => {
    const response = await get<GruhUdhyogDashboardApiResponse>(
      `${JIVANDHARA_BASE}/product-dashboard/`,
      SILENT_LIST
    );
    return response.data;
  };
}

export const gruhUdhyogDashboardService = new GruhUdhyogDashboardService();
